<template>
  <div class="chatroom">
    <div class="chat-avatar">
      <avatar :avatarUrl="avatarUrl"
              :size="avatarSize"></avatar>
    </div>
    <div style="margin-left:10px;"></div>
    <div class="chat-content">
      <chat-content :id="id"
                    :flag="flag"
                    :articleSetion="articleSetion"
                    :articleTranslate="articleTranslate"
                    :dateTime="dateTime"
                    :fontSize="14"
                    :chatStyle="true"
                    :isMore="isMore"
                    v-bind="$attrs"
                    v-on="$listeners"
                    ref="chatContent"></chat-content>
    </div>
  </div>
</template>

<script>
/**
 * David 2019/7/19
 * 帖子回复的组件
 */
import avatar from '@/components/avatar';
import chatContent from '@/components/socialMedia/articleContent';

export default {
  props: {
    flag: String,//标记后台使用还是web端使用，web端需要验证回复的权限
    avatarUrl: String,
    avatarSize: {
      type: [Number, String],
      default: 40
    },
    id: String,
    isMore: Boolean,
    articleSetion: String,
    articleTranslate: String,
    dateTime: String,
  },
  components: {
    avatar,
    chatContent
  },
  methods: {
    more (id) {
      this.$emit('more', id);
    }
  }
};
</script>

<style lang="scss" scoped>
.chatroom {
  display: flex;
}
</style>
